// extracted by mini-css-extract-plugin
export default {"container":"login_container__+ruY2","form":"login_form__cBnz2"};